"use client";

import { Card, Button } from "antd";
import { Link } from "react-router-dom";
import useLanguageStore from "../../stores/languageStore.ts";

export default function Home() {
  const { t } = useLanguageStore();

  const shortcuts = [
    {
      title: t("home.dashboardTitle"),
      description: t("home.dashboardDescription"),
      to: "/dashboard",
      icon: "fa-chart-line",
    },
    {
      title: t("home.placesTitle"),
      description: t("home.placesDescription"),
      to: "/places",
      icon: "fa-location-dot",
    },
    {
      title: t("home.ticketsTitle"),
      description: t("home.ticketsDescription"),
      to: "/tickets",
      icon: "fa-ticket",
    },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl p-8 shadow-soft border border-gray-100">
        <p className="text-sm text-gray-500 mb-2">{t("home.welcome")}</p>
        <h1 className="text-3xl font-bold text-black">{t("home.title")}</h1>
        <p className="text-gray-600 max-w-3xl">{t("home.description")}</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/dashboard">
            <Button type="primary">{t("home.goToDashboard")}</Button>
          </Link>
          <Link to="/users">
            <Button>{t("home.manageUsers")}</Button>
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {shortcuts.map((item) => (
          <Link key={item.to} to={item.to}>
            <Card className="hover:shadow-lg transition-shadow h-full">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-lg font-semibold text-black">{item.title}</div>
                  <p className="text-gray-600 mb-4">{item.description}</p>
                  <div className="text-primary-600 text-sm font-medium flex items-center gap-2">
                    {t("home.open")} <i className={`fa-solid ${item.icon}`}></i>
                  </div>
                </div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}

